import { canAccess, type UserAccess } from "@hisense/shared";

/**
 * Cột nào của khối "Chứng từ gần đây" trên trang nhà cung cấp được hiện (và được gọi API).
 *
 * Chép đúng hàng rào của máy chủ, không suy thêm: đơn mua đi qua `requireInternal` nên chỉ cần ô Đơn mua
 * (tài khoản theo vai trò: bộ mẫu của vai trò). Khiếu nại nhà cung cấp và Tài chính còn chặn
 * `requireRole('admin','manager')`, mà với tài khoản theo vai trò thì vế đó loại kế toán và người chỉ xem
 * dù bảng mẫu có tick — bỏ vế đó thì họ thấy một cột báo lỗi thay vì không thấy cột.
 */
export function supplierDocumentAccess(access: UserAccess | null): { po: boolean; claims: boolean; ap: boolean } {
  if (!access) return { po: false, claims: false, ap: false };
  const internal = access.mode === "custom" || access.role === "admin" || access.role === "manager";
  return {
    po: canAccess(access, "purchaseOrders", "view"),
    claims: internal && canAccess(access, "supplierClaims", "view"),
    ap: internal && canAccess(access, "finance", "view"),
  };
}
